import { render, staticRenderFns } from "./ModalBoxEdit.vue?vue&type=template&id=8306866e"
import script from "./ModalBoxEdit.vue?vue&type=script&lang=js"
export * from "./ModalBoxEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports